import { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import project1 from "../../assets/images/NFTsearch.png";
import project2 from "../../assets/images/otivation.jpeg";
import project3 from "../../assets/images/cryptobey.gif";
import project4 from "../../assets/images/kontiki.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

const Project = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);
  }, []);

  return (
    <>
      <div className="container">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              arr={[
                "P",
                "e",
                "r",
                "s",
                "o",
                "n",
                "a",
                "l",
                " ",
                "P",
                "r",
                "o",
                "j",
                "e",
                "c",
                "t",
              ]}
              index={15}
            />
          </h1>
          <div className="project-container">
            <article className="project-item">
              <div className="project-item-image">
                <img src={project1} alt="project" />
              </div>
              <h3>
                NFT Search{" "}
                <a
                  target="_blank"
                  href="https://github.com/ohbrian19/NFTsearch"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faGithub} color="black" />
                </a>
              </h3>

              <span className="project-item-description">
                NFTsearch is an iOS mobile app to keep track of your NFTs and
                search for any NFTs. It supports both ERC1155 and ERC721
                contract. NFTsearch is built with React Native and uses Realm
                Database to store data right on client devices.
              </span>
            </article>
            <article className="project-item">
              <div className="project-item-image">
                <img src={project2} alt="project" />
              </div>
              <h3>
                Oitvation{" "}
                <a
                  target="_blank"
                  href="https://github.com/ohbrian19/otivation"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faGithub} color="black" />
                </a>
              </h3>
              <span className="project-item-description">
                Otivation is an iOS/Android cross-platform mobile app for
                workouts to keep in track of what you achieved day to day.
                Otivation is built with React Native and Node.js.
              </span>
            </article>
            <article className="project-item">
              <div className="project-item-image">
                <img src={project3} alt="project" />
              </div>
              <h3>
                cryptObey{" "}
                <a
                  target="_blank"
                  href="https://github.com/ohbrian19/cryptobey"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faGithub} color="black" />
                </a>
              </h3>
              <span className="project-item-description">
                cryptObey uses CoinMarketCap API and Rates API to bring you
                real-time information of top 100 cryptocurrencies and over 30
                different exchange rates
              </span>
            </article>
            <article className="project-item">
              <div className="project-item-image">
                <img src={project4} alt="project" />
              </div>
              <h3>
                Kontiki{" "}
                <a
                  target="_blank"
                  href="https://github.com/teammustard/kontiki_component_ohbrian19"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faGithub} color="black" />
                </a>
              </h3>
              <span className="project-item-description">
                Kontiki is a full stack web application replica of Contiki
                Travel Tours's item page
              </span>
            </article>
          </div>
        </div>
      </div>
      <Loader type="ball-pulse" />
    </>
  );
};

export default Project;
